import React from 'react';
import classNames from 'classnames';
import { graphql, Link, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import * as styles from './blogCard.module.scss';

const BlogCard = ({
  className,
  url,
  image,
  alt,
  title,
  titleEl: TitleEl,
  date,
  author,
  more,
}) => {
  const { defaultBlogImg } = useStaticQuery(graphql`
    {
      defaultBlogImg: file(relativePath: { eq: "default-square.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <article className={classNames(styles.card, className)}>
      <Link to={url} tabIndex="-1">
        {image.fluid
          ? (
            <Img
              className={styles.image}
              fluid={image.fluid}
              alt={image.alt}
            />
          ) : (
            <Img className={styles.image} fluid={defaultBlogImg.childImageSharp.fluid} />
          )}
      </Link>

      <TitleEl className={styles.title}>
        <Link to={url}>
          {title}
        </Link>
      </TitleEl>

      {(date || author) && (
        <p className={styles.meta}>
          {date
          && (
            <span className={styles.metaDate}>{date}</span>
          )}

          {author && author}
        </p>
      )}

      {more && <Link to={url} className={styles.more} tabIndex="-1">{more}</Link>}
    </article>
  );
};

BlogCard.defaultProps = {
  image: null,
  titleEl: 'h2',
  date: '',
  author: '',
  more: '',
};

export default BlogCard;
